var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5156 0.8125C10.0637 0.8125 8.79242 1.43687 8 2.49227C7.20758 1.43687 5.93633 0.8125 4.48438 0.8125C3.3286 0.813803 2.22053 1.27351 1.40327 2.09077C0.586011 2.90803 0.126303 4.0161 0.125 5.17188C0.125 10.0938 7.42273 14.0777 7.73352 14.2422C7.81543 14.2863 7.90699 14.3093 8 14.3093C8.09301 14.3093 8.18457 14.2863 8.26648 14.2422C8.57726 14.0777 15.875 10.0938 15.875 5.17188C15.8737 4.0161 15.414 2.90803 14.5967 2.09077C13.7795 1.27351 12.6714 0.813803 11.5156 0.8125ZM8 13.1031C6.71609 12.355 1.25 8.94695 1.25 5.17188C1.25112 4.31441 1.59224 3.49238 2.19856 2.88606C2.80488 2.27974 3.62691 1.93862 4.48438 1.9375C5.85195 1.9375 7.00016 2.66594 7.47969 3.83594C7.52207 3.93911 7.59416 4.02735 7.6868 4.08945C7.77945 4.15155 7.88847 4.18471 8 4.18471C8.11153 4.18471 8.22055 4.15155 8.3132 4.08945C8.40584 4.02735 8.47793 3.93911 8.52031 3.83594C8.99984 2.66383 10.148 1.9375 11.5156 1.9375C12.3731 1.93862 13.1951 2.27974 13.8014 2.88606C14.4078 3.49238 14.7489 4.31441 14.75 5.17188C14.75 8.94133 9.2825 12.3543 8 13.1031Z",
    fill: "#034A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineHeart);
export default __webpack_public_path__ + "static/media/outline_heart.a7cc68c074ce55ca30ea16e01e1aa0dd.svg";
export { ForwardRef as ReactComponent };